import { render, staticRenderFns } from "./soil-area-echarts-header.vue?vue&type=template&id=70c3dbf6&scoped=true&"
import script from "./soil-area-echarts-header.vue?vue&type=script&lang=js&"
export * from "./soil-area-echarts-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c3dbf6",
  null
  
)

export default component.exports